/**
 * syncMainConditionThunk.ts
 *
 * This thunk fetches and synchronizes the main condition
 * in the insights filter. It can optionally flush the Redis cache.
 * This is used when test data is imported or deleted from the
 * Admin Dashboard.
 *
 */

/* Redux Toolkit */
import { createAsyncThunk } from "@reduxjs/toolkit";

/* React Redux */
import { RootState } from "src/redux/store";
import { setInsightsFilterValue } from "src/redux/features/insights-filter/insightsFilterSlice";

/* Tunks */
import { flushRedisCache } from "src/redux/thunks/redis-cache/redisCacheThunk";
import { fetchMainConditions } from "src/redux/thunks/insights-filter/main-condition/mainConditionThunk";

/* Interfaces */
import { FilterType } from "src/shared/interfaces/insights-filter/InsightsFilter";
import { resetTestData } from "src/redux/features/test-data/testDataSlice";

export const syncMainCondition = createAsyncThunk<
  void,
  { flush?: boolean },
  { state: RootState }
>(
  "syncMainCondition",
  async (
    { flush = false } = {},
    { dispatch, getState }
  ) => {
    if (flush) {
      dispatch(flushRedisCache());
    }

    const result = await dispatch(fetchMainConditions());
    const conditions = (result.payload as string[]) || [];

    const currentMain =
      getState().insightsFilter.mainCondition.value;

    /**
     * If there are no main conditions, reset the test data.
     * This is required when the database is clearde manually.
     * Otherwise, the state'testData' will be out of sync.
    //  */
    // if (conditions.length === 0) {
    //   dispatch(resetTestData());
    //   return;
    // }

    if (!conditions.includes(currentMain ?? "")) {
      dispatch(
        setInsightsFilterValue({
          key: FilterType.MAIN_CONDITION,
          value: conditions[0],
        })
      );
    }
  }
);
